import { Controller, UseFormReturn } from 'react-hook-form';
import { ConfigurationFormData } from '../../types';
import CalendarSelect from '../CalendarPicker/CalendarSelect';

interface DateFieldProps {
  control: UseFormReturn<ConfigurationFormData>['control'];
  fieldName: keyof ConfigurationFormData;
  label: string;
  mandatory: boolean;
}

const DateField = ({ control, fieldName, label, mandatory }: DateFieldProps) => {
  return (
    <Controller
      control={control}
      name={fieldName}
      rules={mandatory ? { required: `Please select ${label}` } : {}}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <CalendarSelect
          onChange={onChange}
          value={(value as string) || ''}
          placeholder="Select Date"
          error={error?.message}
        />
      )}
    />
  );
};

export default DateField;
